import { render, staticRenderFns } from "./LastUpdated.vue?vue&type=template&id=0c4ca6c4&"
import script from "./LastUpdated.vue?vue&type=script&lang=ts&"
export * from "./LastUpdated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports